import React from "react";
import { Phone, Mail, Globe, MapPin, ArrowRight } from "lucide-react";
import WhatsAppIcon from "../WhatsAppIcon";

function Tile({ href, target, label, value, Icon, accent, testId }) {
  return (
    <a href={href} target={target} rel={target === "_blank" ? "noreferrer" : undefined} className="card-premium p-4 group" data-testid={testId}>
      <div className="flex items-center gap-3">
        <div className={`w-11 h-11 rounded-xl grid place-items-center ${accent.bg} ${accent.text} group-hover:scale-105 transition-transform`}>
          <Icon className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[11px] uppercase tracking-wider text-[var(--melopa-muted)] font-semibold">{label}</div>
          <div className="font-bold text-navy truncate">{value}</div>
        </div>
        <ArrowRight className={`w-4 h-4 text-[var(--melopa-muted)] ${accent.hoverArrow} group-hover:translate-x-0.5 transition-all`} />
      </div>
    </a>
  );
}

export default function ConnectTiles({ phoneFmt, phoneDigits, waLink, email, website, websiteHost, address, mapLink }) {
  return (
    <div className="p-5 md:p-7">
      <div className="kicker mb-2">Connect</div>
      <div className="grid sm:grid-cols-2 gap-3">
        <Tile
          href={`tel:+91${phoneDigits}`}
          label="Call"
          value={`+91 ${phoneFmt}`}
          Icon={Phone}
          accent={{ bg: "bg-gradient-to-br from-[#dbeafe] to-[#eff6ff]", text: "text-navy", hoverArrow: "group-hover:text-navy" }}
          testId="card-call"
        />
        <Tile
          href={waLink}
          target="_blank"
          label="WhatsApp"
          value="Chat with us"
          Icon={WhatsAppIcon}
          accent={{ bg: "bg-gradient-to-br from-[#dcfce7] to-[#f0fdf4]", text: "text-[var(--melopa-green)]", hoverArrow: "group-hover:text-[var(--melopa-green)]" }}
          testId="card-whatsapp"
        />
        <Tile
          href={`mailto:${email}`}
          label="Email"
          value={email}
          Icon={Mail}
          accent={{ bg: "bg-gradient-to-br from-[#fef3c7] to-[#fffbeb]", text: "text-[var(--melopa-saffron)]", hoverArrow: "group-hover:text-[var(--melopa-saffron)]" }}
          testId="card-email"
        />
        <Tile
          href={website}
          target="_blank"
          label="Website"
          value={websiteHost}
          Icon={Globe}
          accent={{ bg: "bg-gradient-to-br from-[#e0e7ff] to-[#eef2ff]", text: "text-navy", hoverArrow: "group-hover:text-navy" }}
          testId="card-website"
        />
        <a href={mapLink} target="_blank" rel="noreferrer" className="card-premium p-4 group sm:col-span-2" data-testid="card-map">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#fee2e2] to-[#fef2f2] grid place-items-center text-[var(--melopa-saffron)] group-hover:scale-105 transition-transform"><MapPin className="w-5 h-5" /></div>
            <div className="min-w-0 flex-1">
              <div className="text-[11px] uppercase tracking-wider text-[var(--melopa-muted)] font-semibold">Address</div>
              <div className="font-bold text-navy">{address}</div>
            </div>
            <ArrowRight className="w-4 h-4 text-[var(--melopa-muted)] group-hover:text-[var(--melopa-saffron)] group-hover:translate-x-0.5 transition-all" />
          </div>
        </a>
      </div>
    </div>
  );
}
